export default __webpack_public_path__ + "static/media/search-white.8ed032bb.svg";